import React, { useRef, useEffect, useState } from "react";
import ListItem from "./ListItem";
import { ListType } from "../types";
import { Draggable, Droppable } from "react-beautiful-dnd";

type Props = {
  items: string[];
  type: ListType;
  onEdit: (index: number, name: string) => void;
  onRemove: (index: number) => void;
  withNumber?: boolean;
};

const List = (props: Props) => {
  const { items, type, onEdit, onRemove, withNumber = true } = props;
  const droppableSpaceRef = useRef<HTMLDivElement>(null);

  const [spaceBelowDiv, setSpaceBelowDiv] = useState(0);

  useEffect(() => {
    const updateSpaceBelowDiv = () => {
      if (droppableSpaceRef.current) {
        const divRect = droppableSpaceRef.current.getBoundingClientRect();
        const screenHeight = window.innerHeight;
        const spaceBelowDiv = screenHeight - (divRect.top + divRect.height);
        setSpaceBelowDiv(spaceBelowDiv);
      }
    };

    // Atualize o espaço abaixo da div quando a janela for redimensionada
    window.addEventListener("resize", updateSpaceBelowDiv);

    // Execute a função inicialmente para calcular o espaço restante
    updateSpaceBelowDiv();

    // Remova o ouvinte de redimensionamento quando o componente for desmontado
    return () => {
      window.removeEventListener("resize", updateSpaceBelowDiv);
    };
  }, []);

  return (
    <Droppable droppableId={type}>
      {(provided) => (
        <>
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {items.map((item, i) => (
              <Draggable key={item} draggableId={item} index={i}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{ ...provided.draggableProps.style }}
                  >
                    <ListItem
                      value={item}
                      key={i}
                      index={i + 1}
                      withNumber={withNumber}
                      onEdit={onEdit}
                      onRemove={onRemove}
                      isLastElement={i + 1 === items.length}
                    />
                    {i + 1 === items.length ? (
                      <div
                        ref={droppableSpaceRef}
                        style={{
                          width: "100%",
                          paddingBottom:
                            type === "waiting" ? "2.9vh" : spaceBelowDiv,
                        }}
                      />
                    ) : null}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
          {/* <div
            style={{
              position: "absolute",
              width: "100%",
              height: "42vh",
              zIndex: -1,
              marginTop: -10,
            }}
          /> */}
        </>
      )}
    </Droppable>
  );
};

export default List;
